export default __webpack_public_path__ + "static/media/recipe.41343d67.jpg";